import { CheckHeavy } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { Localization } from '../../Localization';
import { defaultTranslations } from '../../constants/defaultTranslations_simplified-registration-BrandPartner';
import { TranslationKey } from '../../models';
import { StyledProgress } from './DocumentStyledComponents';

interface IDocumentLoadingProgressProps {
  uploading: boolean;
  uploadFinished: boolean;
}

const classes = {
  uploadProgress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '23px',
  },
  uploadProgressDone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '23px',
    '&::before': {
      margin: '-4px 8px 0 10px',
      fontSize: '22px',
      lineHeight: '22px',
    },
  },
};

export const DocumentLoadingProgress: FC<IDocumentLoadingProgressProps> = (props) => {
  const { uploading, uploadFinished } = props;
  const { getTestIdProps } = useTestId();

  const renderLoadingProgress = () => {
    const progressSize = 16;
    const textUploading = (
      <Localization
        id={TranslationKey.uploading}
        defaultMessage={defaultTranslations.uploading}
        {...getTestIdProps('uploading-text')}
      />
    );
    const textDone = (
      <Localization
        id={TranslationKey.uploadDone}
        defaultMessage={defaultTranslations.uploadDone}
      />
    );
    const progress = (
      <StyledProgress
        size={progressSize}
        {...getTestIdProps('progress-size')}
      />
    );

    return (
      <CheckHeavy
        sx={uploadFinished ? classes.uploadProgressDone : classes.uploadProgress}
        {...getTestIdProps('loading-progress')}
      >
        {uploading ? progress : null}
        {uploadFinished ? textDone : textUploading}
      </CheckHeavy>
    );
  };

  const documentLoadingProgress = uploading || (uploadFinished && renderLoadingProgress());

  return <div>{documentLoadingProgress}</div>;
};
